import { api } from "@/api"

import type { MaybeRef } from "@vueuse/core"
import { useQueries } from "@tanstack/vue-query"

export type GratuityReportQuery = {
  start?: string
  end?: string
}

type GratuityReportDatapoint = DeepReadonly<{
  start: Date
  end: Date
  value: number
}>

type GratuityReportResponse = DeepReadonly<{
  dataset: GratuityReportDatapoint[]
  granularity: Granularity
}>

const gratuityReport = async (
  query: GratuityReportQuery
): Promise<GratuityReportResponse> => {
  const { body } = await api.get<
    RecursivelyConvertDatesToStrings<GratuityReportResponse>
  >("/reports/gratuity/", {
    query: query,
  })
  return {
    ...body,
    dataset: body.dataset.map((entry) => ({
      ...entry,
      start: DateFns.parseISO(entry.start),
      end: DateFns.parseISO(entry.end),
    })),
  }
}

export const useGratuityReport = (
  queries: MaybeRef<MaybeRef<GratuityReportQuery>[]>
) =>
  useQueries({
    queries: computed(() =>
      unref(queries).map((query) => ({
        queryKey: [BASE_GRATUITY_REPORT_QUERY_KEY, query],
        queryFn: () => gratuityReport(unref(query)),
      }))
    ),
  })
